module.exports = __webpack_public_path__ + "img/neurala.9fe3eb27.jpg";